import axios from '@/libs/api.request'

export const benefitCardList = () => {
  return axios.request({
    url: 'benefit-card/admin/list',
    method: 'get',
  })
}

export const benefitCardCreate = (data) => {
  return axios.request({
    url: 'benefit-card/admin/',
    method: 'post',
    data,
  })
}

export const benefitCardUpdate = (id, data) => {
  return axios.request({
    url: `benefit-card/admin/${id}`,
    method: 'put',
    data,
  })
}

export const benefitCardDelete = (id) => {
  return axios.request({
    url: `benefit-card/admin/${id}`,
    method: 'delete',
  })
}

export const benefitCardQrcode = (id, data) => {
  return axios.request({
    url: `benefit-card/admin/${id}/qrcode`,
    method: 'post',
    data: data || {},
  })
}

export const benefitCardClaims = (id, params) => {
  return axios.request({
    url: `benefit-card/admin/${id}/claims`,
    method: 'get',
    params,
  })
}
